import { Swiper, Pagination, Autoplay } from 'swiper';
import 'swiper/scss';
import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

Swiper.use(Pagination);
Swiper.use(Autoplay);

class SliderHero extends HTMLElement {
  constructor() {
    super();
    this.autoplay = {
      delay: 1000,
      disableOnInteraction: true,
      pauseOnMouseEnter: true,
    };
    this.slider = null;
    this.$items = this.querySelector('.js-hero-slider__items');
    this.$pagination = this.querySelector('.js-hero-slider__pagination');
    if (this.$items) this.setupSlider();
  }

  setupSlider() {
    // Get autoplay settings
    if (this?.dataset?.sliderAutoplaySpeed) {
      const speed = parseInt(this.dataset.sliderAutoplaySpeed, 10);
      this.autoplay.delay = speed * 1000; // convert from seconds to ms
    }
    if (this?.dataset?.sliderAutoplay && this.dataset.sliderAutoplay === 'false') {
      this.autoplay = false;
    }
    this.slider = new Swiper(this.$items, {
      slidesPerView: 1,
      pagination: {
        el: this.$pagination,
        clickable: true,
      },
      autoplay: this.autoplay,
    });

    GLightbox({
      selector: '.slider-lightbox',
      loop: false,
      videosWidth: 1920,
      videosHeight: 1080,
    });
  }
}
export default function init() {
  customElements.define('slider-hero', SliderHero);
}
